import React, { useEffect, useState } from 'react';
import getPropertyFooterData from '@/queries/property/getPropertyFooterData.graphql';
import { PbsKidsProperty, Scalars } from '@/types/pbskids-graph';
import { queryGraphClient } from '@/utils/graphql';
import { ResolvedPageThemes } from '@/utils/theming-system';
import StandardFooter from './StandardFooterView';
import ProducerFooter from './ProducerFooterView';

type FooterProps = {
  propertyId?: Scalars['ID']['output'],
  resolvedPageThemes?: ResolvedPageThemes,
  footerSticker?: string,
  allowProducerHeaderFooter?: boolean,
};

export default function SiteFooter({
  propertyId,
  resolvedPageThemes,
  footerSticker,
  allowProducerHeaderFooter, // TODO: allowProducerHeaderFooter will eventually be removed.
}: FooterProps) {
  const [ propertyData, setPropertyData ] = useState<PbsKidsProperty|null>(null);

  useEffect(() => {
    if (!propertyId) return;

    queryGraphClient(getPropertyFooterData, { propertyId: propertyId })
      .then((data) => {
        setPropertyData(data.pbsKidsProperty);
      });

    return () => {
      setPropertyData(null);
    };
  }, [ propertyId ]);

  if (allowProducerHeaderFooter && propertyId) {
    return <ProducerFooter
      propertyData={propertyData}
      resolvedPageThemes={resolvedPageThemes}
      footerSticker={footerSticker}
    />;
  }

  return <StandardFooter />;
}
